var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 395,
    height: 34,
    viewBox: "0 0 395 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_566_1096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 24.1651V5.19396V0.910156H391V26.001L383.666 10.0897L373.512 26.001L366.178 10.0897L358.28 26.001L350.382 10.0897L341.92 26.001L332.894 11.9257L323.867 26.001L315.969 10.0897L307.507 26.001L298.481 10.0897L290.583 26.001L282.685 10.0897L273.659 26.001L265.761 10.0897L256.735 26.001L248.273 10.0897L239.811 26.001L231.348 10.0897L222.322 26.001L214.988 10.0897L206.526 26.001L197.5 10.0897L189.038 26.001L181.14 10.0897L172.114 26.001L163.652 10.0897L155.19 26.001L146.727 11.9257L137.137 26.001L129.803 11.9257L122.469 26.001L112.879 11.9257L104.417 26.001L95.3907 11.9257L88.0569 26.001L79.0306 10.0897L70.5685 26.001L62.1064 10.0897L54.2085 26.001L45.7464 10.0897L36.156 26.001L28.258 10.0897L19.7959 26.001L11.898 10.0897L4 24.1651Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_566_1096",
    x: 0,
    y: 0.910156,
    width: 395,
    height: 33.0898,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_566_1096"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_566_1096",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.992f36efd8bc2da90f2bffb1ebde605a.svg";
export { ForwardRef as ReactComponent };